<template>
  <section v-if="getContacts">
    <div id="container-contacts-form" class="container d-flex">
      <div class="text-align-start formHeader">
        <img src="/imgs/icons/adv-logo-sm.png" alt="Advance Management Logo" style="max-width: 2em; margin-right: .5em">
        <span style="vertical-align: middle; font-weight: 600">Contatos</span>
      </div>
      <div id="div-title">
        <i class="fa fa-address-book fa-2x" aria-hidden="true" style="color: rgb(28,134,154)"></i>
        <h2 id="container-title">Cadastro de Contatos</h2>
      </div>
      <form action="" id="contacts-form">
        <div class="input-group">
          <label for="contactName">Nome &nbsp;&nbsp;&nbsp;</label>
          <input class="form-control" name="contactName" type="text" v-model="contact.name"
            placeholder="Insira o nome do contato" required>
        </div>

        <!-- Toggle Telefone / Ramal com ícone dentro do campo -->
        <div class="input-group mt-2" style="align-items: center;">
          <label style="width: 100px; font-weight: 600; margin-right: 10px;">
            {{ contactType === 'phone' ? 'Telefone' : 'Ramal' }}
          </label>

          <div style="flex: 1; position: relative; display: flex; align-items: center;">
            <vue-tel-input
              v-if="contactType === 'phone'"
              v-model="contact.phone"
              :inputOptions="optionsTelInput"
              mode="international"
              :default-country="'BR'"
              style="width: 100%; padding-right: 40px;"
            />
            <input
              v-else
              type="text"
              v-model="contact.phone"
              placeholder="Insira o ramal"
              maxlength="4"
              @input="contact.phone = contact.phone.replace(/\D/g, '').slice(0, 4)"
              class="form-control"
              style="width: 100%; padding-right: 40px;"
            />

            <button
              type="button"
              @click="toggleContactType"
              style="position: absolute; right: -98px; background: none; border: none; cursor: pointer; font-size: 2.0em; color: rgb(28, 134, 154); height: 100%; display: flex; align-items: center;"
              :title="contactType === 'phone' ? 'Alternar para ramal' : 'Alternar para telefone'"
            >
              <i :class="contactType === 'phone' ? 'fas fa-toggle-on' : 'fas fa-toggle-off'"></i>
            </button>
          </div>
        </div>

        <div class="input-group mt-2">
          <select class="form-control mr-3 ml-3" name="id-cpf" id="id-cpf" v-model="idCpf" style="flex: 1">
            <option value="id" selected>ID</option>
            <option value="cpf">CPF</option>
            <option value="cnpj">CNPJ</option>
          </select>
          <input class="form-control" name="contactKey" type="text" v-model="contact.unique_key"
            :placeholder="maskPlaceholder" @input="applyMask" style="flex: 4">

        </div>
        <div v-if="saving">
          <p id="saving"><strong><i class="fas fa-spinner fa-pulse"></i> Salvando contato...</strong></p>
        </div>
        <div v-else>
          <button type="submit" class="btn btn-success" id="btn-save" form="chamadoForm"
            @click.prevent="saveContact()"><i class="fas fa-check"></i>
            Salvar
          </button>
          <button type="submit" class="btn btn-danger" id="btn-cancel" form="chamadoForm"
            @click.prevent="resetContact()"><i class="fas fa-window-close fa-fw"></i>
            Cancelar
          </button>
        </div>
      </form>
    </div>
  </section>
</template>

<script>

import { mapActions, mapGetters } from 'vuex';
import VueTheMask from 'vue-the-mask';

Vue.use(VueTheMask)

export default {
  name: "Contacts",
  data() {
    return {
      contact: {
        name: "",
        phone: "",
        unique_key: "",
      },
      idCpf: "cpf",
      contactType: "phone",
      saving: false,
      optionsTelInput: {
        placeholder: 'Insira o telefone',
        required: true
      }
    };
  },
  computed: {
    maskPlaceholder() {
      if (this.idCpf === 'cpf') {
        return 'XXX.XXX.XXX-XX';
      } else if (this.idCpf === 'cnpj') {
        return 'XX.XXX.XXX/XXXX-XX';
      } else {
        return 'Id do contato';
      }
    },
    ...mapGetters(['getContacts']),
  },
  methods: {
    ...mapActions(['setMessage']),

    toggleContactType() {
      this.contactType = this.contactType === 'phone' ? 'extension' : 'phone';
      this.contact.phone = '';
    },

    onlyDigits() {
      this.contact.extension = this.contact.extension.replace(/\D/g, '').slice(0, 4);
    },
    applyMask() {
      if (this.idCpf === 'cpf') {
        let value = this.contact.unique_key.replace(/\D/g, '').slice(0, 11);
        this.contact.unique_key = value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
      } else if (this.idCpf === 'cnpj') {
        let value = this.contact.unique_key.replace(/\D/g, '').slice(0, 14);
        this.contact.unique_key = value.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
      }
    },
    checkForm: function () {
      if (this.contact.name == '') {
        Swal.fire({
          html: 'O campo "Nome" não foi preenchido!',
          type: "warning",
          showCloseButton: true,
          confirmButtonText: '<i class="fa fa-thumbs-up"></i>'
        });
        return false;
      }

      if (this.contact.phone == '') {
        Swal.fire({
          html: `O campo "${this.contactType === 'phone' ? 'Telefone' : 'Ramal'}" não foi preenchido!`,
          type: "warning",
          showCloseButton: true,
          confirmButtonText: '<i class="fa fa-thumbs-up"></i>'
        });
        return false;
      }

      if (this.contact.unique_key == '') {
        Swal.fire({
          html: 'O campo "ID/ CPF/ CNPJ" não foi preenchido!',
          type: "warning",
          showCloseButton: true,
          confirmButtonText: '<i class="fa fa-thumbs-up"></i>'
        });
        return false;
      }

      return true;
    },


    saveContact: function () {
      if (this.checkForm()) {
        this.saving = true;

        axios.post("dialer/saveContact", this.contact)
          .then(({ data }) => {
            if (data.passed == false) {
              let str = '';
              Object.keys(data.errors).forEach(key => {
                str += data.errors[key];
              });

              Swal.fire({
                type: "warning",
                title: "Falha ao salvar contato",
                text: str
              }).then(() => {
                this.saving = false;
              });

              return;
            }

            Swal.fire({
              type: "success",
              title: "Feito!",
              text: "Contato salvo com sucesso!"
            }).then(() => {
              this.saving = false;
              this.contact.name = "";
              this.contact.phone = "";
              this.contact.unique_key = "";
              this.contactType = "phone";
              this.idCpf = "cpf";
            });
          });
      }
    },


    resetContact: function () {
      Swal.fire({
        title: 'Deseja descartar as informações?',
        text: 'Você perderá as alterações não salvas!',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: 'rgb(28,134,154)',
        confirmButtonText: 'Sim, descartar',
        cancelButtonText: 'Voltar ao formulário'
      }).then((result) => {
        if (result.value) {
          this.saving = false;
          this.contact.name = "";
          this.contact.phone = "";
          this.contact.unique_key = "";
          this.contactType = "phone";
          this.idCpf = "cpf";
        }
      });
    }

  }
}
</script>

<style scoped>
.formHeader {
  background-color: rgb(28, 134, 154);
  border-top: 3px solid #f38630;
  color: white;
  padding: 0.2em;
  display: flex;
  border-radius: 20px 20px 0px 0px
}

.input-group {
  width: 90%;
  align-self: center;
  line-height: 2.55;
}

#container-contacts-form {
  margin: 3em;
  margin-top: 10%;
  width: 40vw;
  border: solid 2px lightgray;
  border-radius: 25px;
  text-align: center;
  flex-direction: column;
  padding: 0
}

#phone-input {
  height: 2.5em;
  align-self: center;
  flex: 3;
}

#saving {
  color: rgb(28, 134, 154);
  font-size: 16px;
  text-align: center
}

#div-title {
  display: flex;
  flex-direction: column;
  margin: 20px;
}

#contacts-form {
  display: flex;
  flex-direction: column;
  text-align: center;
}

#buttonGroup {
  display: flex;
  justify-content: center;
}

#btn-save {
  border: solid 2px #008000;
  border-radius: 20px;
  background-color: #008000;
  color: white;
  transition: 0.5s
}

#btn-save:hover {
  color: #008000;
  background-color: white;
}

#btn-cancel {
  border: solid 2px #b30000;
  border-radius: 20px;
  background-color: #b30000;
  color: white;
  transition: 0.5s
}

#btn-cancel:hover {
  color: #b30000;
  background-color: white;
}

.input-group label {
  width: 100px;
}

section {
  display: flex;
  justify-content: center;
}

h2 {
  color: rgb(28, 134, 154)
}

label {
  margin: 10px;
  font-size: 16px;
  font-weight: 500;
}

select {
  align-self: center;
}

input {
  width: 40px;
  align-self: center;
}

button {
  width: 120px;
  margin: 20px;
  border-radius: 10px !important
}
</style>
